import classes from './booking-link.module.scss';
import { ReactComponent as InfoIcon } from '../../../images/icons/info-icon-gray-bl.svg';

function CompleteBookingWarning() {
    return (
        <div className={classes.completeBookingWarning}>
            <InfoIcon />
            <p>30 minutes to secure your booking</p>
        </div>
    );
}
export default CompleteBookingWarning;
